import React from 'react';
import { connect } from 'redux-bundler-react'

class ModalWindow extends React.Component {
  render(){
    const { modalChildren, modalOptions } = this.props;

    if(!modalChildren.length) return null;

    return (
      <div className="modal show">
        <div className="modal-dialog modal-lg" style={{maxHeight:'98%', display:'flex', flexDirection:'column'}}>
          <div className="modal-content thin-scrollbar" style={{maxHeight:'98%', display:'flex', flexDirection:'column', overflow:'auto'}}>
            {
              modalChildren.map((component, i) => {
                const Comp = component;
                return <Comp key={i} {...modalOptions} />
              })
            }
          </div>
        </div>
      </div>
    )
  }
}

export default connect(
  'selectModalChildren',
  'selectModalOptions',
  'doCloseModalWindow',
  ModalWindow
);